import { mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './ConfirmUserStatus.scss';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { updateUserStatus } from '../../../store/apis/adminService';

function ConfirmUserStatus({ isOpen, toggle, userData, onStatusUpdated }) {
  const { user } = userData || {};

  const { mutate: updateStatus } = useMutation({
    mutationFn: updateUserStatus,
    onSuccess: () => {
      toast.success('Status updated successfully', {
        className: 'toast-success',
      });
      toggle();
      onStatusUpdated();
    },
    onError: () => {
      toast.error('Failed to update status', {
        className: 'toast-error',
      });
    },
  });

  const handleUpdate = () => {
    const payload = {
      id: user?.ID,
      userName: user?.UserName,
      userFullName: user?.UserFullName,
      email: user?.Email,
      employeeId: user?.EmployeeID,
      roleId: user?.RoleID,
      isActive: !user?.IsActive,
      isDefaultDashboard: user?.ISDefaultDashboard,
      canViewSelfService: user?.CanViewSelfService,
      canViewHR: user?.CanViewHR,
      canViewOtherEmp: user?.CanViewOtherEmployee,
      hrCoCd: user?.HRCoCd,
      adAuthentication: user?.ADAuthentication,
      password: '',
    };

    updateStatus(payload);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="delete-role-cancel-icon">
            <Icon path={mdiFileRemoveOutline} color="#D92D20" size={0.7} />
          </div>
        </div>
        <div>
          <h5>Confirmation</h5>
          <p>Are you sure you want to change the status of this user?</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="custom-light-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={handleUpdate}
          >
            Yes
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmUserStatus;
